import { render } from "./ValidationComponent.vue?vue&type=template&id=472564c4"
import script from "./ValidationComponent.vue?vue&type=script&lang=js"
export * from "./ValidationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__